
  window.onload = () => {
    document.body.classList.add('loaded');
  };
function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}
if(document.querySelector(".sticky-link-container")){
      document.documentElement.style.setProperty('--sticky-link-height', `${Math.round(document.getElementById('section-sticky-link').clientHeight)}px`);
} else {
  document.documentElement.style.setProperty('--sticky-link-height', `0px`);
}
document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

// Header js
if(document.querySelector('.js-mm-opener')){
  document.querySelector('.js-mm-opener').addEventListener('click', () => {
    document.querySelector('body').classList.toggle('open-menu-drawer');
  });
}

document.addEventListener('click', (e) => {
  if(
    e.target === document.querySelector('.menu-drawer__overlay')
  ) {
    document.querySelector('body').classList.remove('open-menu-drawer');
  }
});

if(document.querySelector('.js-search-openner')){
  document.querySelector('.js-search-openner').addEventListener('click', () => {
    document.querySelector('body').classList.toggle('open-search-drawer');
    if (document.querySelector('body').classList.contains('open-menu-drawer')){
      document.querySelector('body').classList.remove('open-menu-drawer');
    }
    document.querySelector('body').classList.remove('scrolled');
  });
  document.querySelector('.search-modal__close-button').addEventListener('click', () => {
    document.querySelector('body').classList.remove('open-search-drawer');
  });
}

document.body.addEventListener('mousedown', (e) => {
    let isClickInsideBanner = document.querySelector('#shopify-section-search-drawer').contains(e.target);
    if (!isClickInsideBanner) {
      document.querySelector('body').classList.remove('open-search-drawer') 
    }
});
let sectionHeroAbout = document.querySelectorAll(".about-hero");
sectionHeroAbout.forEach((item,index) => {
  if(index == 0) return;
  let heightContent = item.querySelector('.s-wrap').offsetHeight;
  item.style.minHeight = heightContent + "px";
});

var elementSectionScroll = document.querySelector('.js-change-bg');

window.addEventListener('scroll', function () {
  if (elementSectionScroll){
    var offsets = elementSectionScroll.getBoundingClientRect();
    var top = offsets.top;
    if (top <= 0) {
      document.body.classList.add("theme-light");
          document.body.classList.remove("theme-dark");
    } else {
      document.body.classList.remove("theme-light");
        document.body.classList.add("theme-dark")
    }
  }
}); 

const fakeKlaviyo = document.querySelectorAll('.fake-klaviyo');
if(fakeKlaviyo){
  fakeKlaviyo.forEach((item) => {
      item.addEventListener('submit', (e) => {
      e.preventDefault();
      const emailInput = document.querySelector('#klaviyo-wrapper .klaviyo-form').querySelector('input[name="email"]');
      emailInput.value = item.querySelector('input').value;
      emailInput.dispatchEvent(new Event('input', {'bubbles': true}));
      document.body.classList.add("subscribe-opened");
      return false;
    });
  });
}
document.querySelectorAll(".btn-close-klaviyo").forEach((element) => {
  element.addEventListener("click", function() {
      document.body.classList.remove("subscribe-opened");
  })
});

function cartdrawerFreeShippingNote() {
  let shippingEls = document.querySelectorAll(
    '.minicart_shipping.show-progression-shipping'
  );
  shippingEls.forEach((shippingEl) => updateFreeShippingNote(shippingEl));
}

function updateFreeShippingNote(shippingEl) {
  let titleProcessEl = shippingEl.querySelector('.title--process');
  let titleSuccessEl = shippingEl.querySelector('.title--success');
  let totalLeftEl = shippingEl.querySelector('.total-left');
  let shippingProgressEl = shippingEl.querySelector('.shipping--progress');
  const formatter = new Intl.NumberFormat(Shopify.locale, {
    style: 'currency',
    currency: Shopify.currency.active == 'AUD' ? 'USD' : Shopify.currency.active,
  });
  if (
    parseInt(shippingEl.dataset.shipping) > parseInt(shippingEl.dataset.total)
  ) {
    titleProcessEl.classList.add('active');
    titleSuccessEl.classList.remove('active');
    let totalLeft = `${formatter.format(
      parseInt(shippingEl.dataset.shipping) -
        parseFloat(shippingEl.dataset.total)
    )}`;
    totalLeftEl.innerHTML = totalLeft;
    shippingProgressEl.style.width = `${
      (parseFloat(shippingEl.dataset.total) /
        parseInt(shippingEl.dataset.shipping)) *
      100
    }%`;
  } else {
    titleProcessEl.classList.remove('active');
    titleSuccessEl.classList.add('active');
    shippingProgressEl.style.width = '100%';
  }
}
cartdrawerFreeShippingNote();
let elmTextTest = document.getElementById("MainContent").firstElementChild;
let textTest = document.getElementById("MainContent").firstElementChild.className;
let pageHandle = document.querySelector('body').className;

// TODO: Use liquid to add 'show-header-fixed' class to the correct page types and remove the condition below
if(elmTextTest.classList.contains('section-slideshow-banner') || elmTextTest.classList.contains('banner-section')  || elmTextTest.classList.contains('section-about-hero') || location.href.includes('products') || textTest.includes('login-page') || location.href.includes('password') || pageHandle.includes('template__page__handle-award')){
  document.body.classList.add('show-header-fixed');
}
/* 
  Check if collection banner has content
  Have to check if the first child has child nodes 
  because the collection banner section contains a text node when it's empty
*/
if(elmTextTest.classList.contains('collection-banner-section')) {
  const banner = document.querySelector('.collection-banner-section');
  if (banner.firstChild.hasChildNodes()) {
    document.body.classList.add('show-header-fixed');
  } 
}
if(document.querySelector('body.template-404')) {
  document.body.classList.add('show-header-fixed');
}
// Add checked to checkbox
const checkboxInputs = document.querySelectorAll('.checkbox-input');
if(checkboxInputs.length > 0){
  checkboxInputs.forEach((checkboxInput) => {
    checkboxInput.addEventListener('click', () => {
      checkboxInput.classList.toggle('checked');
    });
  });
}

//Check Customer login or logout
function checkLoginState() { 
    document.querySelectorAll('a[href="/account/logout"]').forEach((item) => {
      item.addEventListener('click', (e) => {
        e.preventDefault();
          fetch("/cart.js").then((response) => response.json()).then((response) => {

              let idSpecialProduct = [];
              for(let i = 0; i < response.items.length; i++) {
                  if(response.items[i].properties._coming_soon && response.items[i].properties._coming_soon == "true"){
                      idSpecialProduct[i] = response.items[i].key;
                  }
              }
              if(idSpecialProduct.length > 0){
                  idSpecialProduct = idSpecialProduct.filter((item) => {
                      return item != "";
                  })
                  for(let i = 0; i < idSpecialProduct.length; i++){
                      fetch("/cart/change.js", {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({'id': idSpecialProduct[i],'quantity': 0})
                      }).then((response) => response.json()).then((response) => {
                        window.location.href = "/account/logout";
                      })
                  }
              }else{
                window.location.href = "/account/logout";
              }
          }).catch((error) =>{
              console.log(error);
              window.location.href = "/account/logout";
          })
      })
    });
}
checkLoginState();

// Change local purchase by select country on footer
const main = document.querySelector('html');
if(document.querySelector('.location-custom')){
  const buttonSelect = document.querySelector('.js-disclosure__button');
  const flagButton = buttonSelect.querySelector('.flag-location');
  const localList = document.querySelector('.js-disclosure__list-wrapper');
  buttonSelect.addEventListener('click', () => {
    localList.classList.toggle('hidden');
  });
  const localItems = localList.querySelectorAll('.js-disclosure__item');
  localItems.forEach((localItem) => {
    // const flagChild = localItem.querySelector('.disclosure__link').innerHTML;
    localItem.addEventListener('click', () => {
      // flagButton.innerHTML = flagChild;
      localList.classList.toggle('hidden');

      const selectedCode = localItem.dataset.countryCode
      document.querySelectorAll('.select-flag-local').forEach((item) => {
        item.classList.remove('selected');
        if (item.dataset.countryCode === selectedCode) {
          item.classList.add('selected');
        }
      });

      if(localItem.classList.contains('is-au')){
        if(main.classList.contains('local-outsite')) {
          main.classList.remove('local-outsite');
          main.classList.add('local-purchase');
          main.setAttribute('ip-selected', 'local-au');
          sessionStorage.setItem('ip-selected', 'local-au');
        } 
      }
      if(localItem.classList.contains('is-int') || localItem.classList.contains('is-uk')){
        if(main.classList.contains('local-purchase')) {
          main.classList.remove('local-purchase');
          main.classList.add('local-outsite');
        }
        if(localItem.classList.contains('is-int')){
          main.setAttribute('ip-selected', 'local-int');
          sessionStorage.setItem('ip-selected', 'local-int');
        }
        if(localItem.classList.contains('is-uk')){
          main.setAttribute('ip-selected', 'local-uk');
          sessionStorage.setItem('ip-selected', 'local-uk');
        }
      }
    })
  });
  const currentIP = sessionStorage.getItem('ip-selected');
  var isIPSelected = false;
  localItems.forEach((localItem) => {
    if ( localItem.classList.contains('is-au') && currentIP === 'local-au' ) {
      isIPSelected = true;
      document.querySelector('.select-flag-local.is-au').classList.add('selected');
    }
    if ( localItem.classList.contains('is-int') && currentIP === 'local-int' ) {
      isIPSelected = true;
      document.querySelector('.select-flag-local.is-int').classList.add('selected');
    }
    if ( localItem.classList.contains('is-uk') && currentIP === 'local-uk' ) {
      isIPSelected = true;
      document.querySelector('.select-flag-local.is-uk').classList.add('selected');
    }
    if ( localItem.classList.contains('is-us') && currentIP === 'local-us' ) {
      isIPSelected = true;
      document.querySelector('.select-flag-local.is-us').classList.add('selected');
    }
  });
  if (!isIPSelected && currentIP !== null) {
    const selectedIp = main.dataset.ipSelected;
    document.querySelectorAll('.flag-location .select-flag-local').forEach((item) => {
      selectedIp === 'local-au' && item.classList.add('selected');
      selectedIp === 'local-int' && item.classList.add('selected');
      selectedIp === 'local-uk' && item.classList.add('selected');
      selectedIp === 'local-us' && item.classList.add('selected');
    });
  }
}
